<template>
    <div class="bagworld-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Bagworld Bespoke Bags Ltd Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Please enter details of your enquiry below.
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Bagworld Bespoke Bags Ltd
                </div>
                <div class="logo">
                    <img src="/images/powered-by-logo-bagworld.png">
                </div>
            </div>
            <div class="box-1">
                <h1>
                    Bespoke Bags with YOUR logo
                </h1>
                <p class="mt-0">
                    We can manufacture any size of Transit Carry bag in a wide range of Materials & colours.
                </p>
                <p>
                    Have your company logo either Screen printed, Embroidered or Heat Transferred onto your Bags.
                </p>
                <p>
                    Having been suppliers to the Window industry for 27 years with Bespoke bags our design & Sales team are here to help with any of your personalised requirements.
                </p>
                <div>
                    <a class="btn-primary _lg" @click.prevent="enquiry_box_open = true">
                        Make Enquiry
                    </a>
                </div>
            </div>
            <div class="overlapping-image">
                <img src="/images/marketing-bagworld-header.png">
            </div>
            <div class="mt-3 mb-3 p-3">
                &nbsp;
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'logged_in_user',
    ],
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'Can I be sent some information about bespoke bags please',
          sending: false,
        }
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 47,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'Bagworld enquiry',
                'value': 'Bagworld enquiry',
              });

              this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been submitted, you will be sent a notification when you receive a reply.'
                });
            });
        },
    },
};
</script>
